var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "plus-button plus-button--small exclude-outside-click",
      attrs: { type: "button" }
    },
    [
      _c("img", {
        staticClass: "exclude-outside-click",
        attrs: { src: require("@/csmworkflow/img/plus.svg") },
        on: { click: _vm.handleClick }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }